import { render, staticRenderFns } from "./BooleanType.vue?vue&type=template&id=65e47fda&scoped=true"
import script from "./BooleanType.vue?vue&type=script&lang=js"
export * from "./BooleanType.vue?vue&type=script&lang=js"
import style0 from "./BooleanType.vue?vue&type=style&index=0&id=65e47fda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e47fda",
  null
  
)

export default component.exports